import { Injectable } from "@angular/core";
import { RulesService } from "./rules/rules.service";
import { ZoneNamesService } from "./zone-names/zone-names.service";
import { ZonesService } from "./zones.service";

@Injectable({
	providedIn: "root",
})
export class AfterWizardActionsService {
	constructor(
		private zoneService: ZonesService,
		private zoneNameService: ZoneNamesService,
		private rules: RulesService,
	) {}

	reset() {
		this.zoneNameService.categoryId$.next(null);
		this.zoneService.reset();
		this.zoneService.zonesOnApplyClicked = {};
		this.rules.ruleToPatch$.next(null);
		this.rules.patchedRuleMap.clear();
	}
}
